import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import Dashboard from "./Class-xii/dashboard/Dashboard";
import StudentInformation from "./Class-xii/studentinfo/StudentInformation";
import Login from "./Class-xii/Login/Login";
import { encodeRoute } from "./utils/routeEncoder";
import Payment from "./Class-xii/payment/Payment";
import PaymentResponse from "./Class-xii/payment/PaymentResponse";
import Adminlogin from "./Admin/Pages/Adminlogin";
import Admindashboard from "./Admin/Pages/Admindashboard";
//import Classxnotice from './Admin/Pages/Classxnotice';
import Classxiinotice from "./Admin/Pages/Classxiinotice";

// export const encodedDashboard = encodeRoute("/dashboard");
// export const encodedStudentInfo = encodeRoute("/class-x-student-info");
// export const encodedLogin = encodeRoute("/class-x-login");
// export const encodedpayment = encodeRoute("/class-x-payment");

// export const encodedadminlogin = encodeRoute("/admin-login");

function App() {
  return (
    // <Router basename='/App'>
     <Router>
      <Routes>
        {/* Redirect base path "/" to encrypted login path */}
        <Route path="/" element={<Login />} />

        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/student-info" element={<StudentInformation />} />
        {/* <Route path={`/${encodedLogin}`} element={<Login />} /> */}
        <Route path="/student-payment" element={<Payment />} />
        <Route path="/admin-login" element={<Adminlogin />} />
        <Route path="/admin-dashboard" element={<Admindashboard />} />
        {/* <Route path="/admin-class-x" element={<Classxnotice />} /> */}
        <Route path="/admin-class-xii" element={<Classxiinotice />} />

        <Route path="/payment-response" element={<PaymentResponse />} />
      </Routes>
    </Router>
  );
}

export default App;
